var map = {
	"./berlin.svg": 27799,
	"./bielefeld.svg": 72259,
	"./bremerhaven.svg": 36080,
	"./de.svg": 18610,
	"./en.svg": 48986,
	"./leaves_left.svg": 65,
	"./leaves_right.svg": 33260,
	"./nrw.svg": 73666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;